import { t } from '@moovly/i18n';
import * as React from 'react';
import { Table, TableBody, TableHeadCol, TableHeader, TableLoader, TableRow } from '../../../components/Table';
import useSortableTableHeader from '../../../hooks/useSortableTableHeader';
import { Subscription } from '../types/subscriptions';
import SubscriptionsTableRow from './SubscriptionsTableRow';

const headers = [
  'type',
  { property: 'assigned_to', sortProp: 'user.full_name' },
  'created_at',
  'starts_at',
  'expires_at',
  'assignments_left',
];

interface SubscriptionsTableProps {
  subscriptions: Subscription[];
  loading: boolean;
  onAssign: (license: Subscription) => void;
  onRevoke: (license: Subscription) => void;
}

const SubscriptionsTable: React.FC<SubscriptionsTableProps> = ({ subscriptions, loading, onAssign, onRevoke }) => {
  const handleAssign = React.useCallback((license: any) => onAssign(license), [onAssign]);
  const handleRevoke = React.useCallback((license: any) => onRevoke(license), [onRevoke]);
  const { SortableTableHeader, sortedData } = useSortableTableHeader(subscriptions, 'user.full_name');
  return (
    <Table>
      <TableHeader>
        <TableRow>
          {headers.map(
            (header) => (
              <SortableTableHeader
                key={typeof header === 'string' ? header : header.property}
                isDefault={header === 'assigned_to'}
                sortBy={typeof header === 'string' ? header : header.sortProp}
                label={t(`licenseManagement.headers.${typeof header === 'string' ? header : header.property}`)}
              />
            ),
            []
          )}
          <TableHeadCol>Actions</TableHeadCol>
        </TableRow>
      </TableHeader>
      <TableBody>
        {sortedData.map((subscription: Subscription) => (
          <SubscriptionsTableRow
            key={`users-table-user-${subscription.id}`}
            subscription={subscription}
            onAssign={handleAssign}
            onRevoke={handleRevoke}
          />
        ))}
        {loading && <TableLoader rows={3} columnns={7} cellWidth={40} />}
      </TableBody>
    </Table>
  );
};
export default SubscriptionsTable;
